import { useMemo } from "react";
import SidebarBrand from "../../components/SidebarBrand";
import AppShell from "../../layout/AppShell";
import { superAdminMenuGroups } from "../../layout/sidebarMenuConfigs";

const SideBar = ({ children }) => {
  const menuGroups = useMemo(() => superAdminMenuGroups, []);

  return (
    <AppShell
      menuGroups={menuGroups}
      sidebarHeader={
        <SidebarBrand
          to="/dashboard"
          subtitle="Super Admin"
          variant="sidebar"
        />
      }
    >
      {children}
    </AppShell>
  );
};

export default SideBar;
